import { TSearchPromosResponse_1 } from '../repositories/newbuilding-promos/v2/search-promos';

export const mapPath = (promosResponse: TSearchPromosResponse_1): string => {
  return promosResponse.path || '';
};
